import React, { useEffect, useReducer } from "react";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import ListenerRules from "./ListenerRules";
import JsonCollapse from "../../Components/JsonCollapse";
import UsedInLink from "../../Components/UsedInLink";
import usedIn from "../../Components/usedIn";
import {
  selectEventHandler,
  setEventHandler,
} from "../../../store/slices/projectSlice";
import { selectFeatures } from "../../../store/slices/featuresSlice";

export default function EventHandler({ uuid, event }) {
  const { featuresModules } = useSelector(selectFeatures);

  const [state, dispatch] = useReducer((prev, action) => {
    switch (action.type) {
      case "edit-label":
        return {
          ...prev,
          Label: action.label,
        };
      case "edit-notes":
        return {
          ...prev,
          Notes: action.notes,
        };
      case "toggle-stop-propagation":
        return {
          ...prev,
          StopPropagation: !prev.StopPropagation,
        };
      case "toggle-module":
        return {
          ...prev,
          IsModule: !prev.IsModule,
        };
      case "update-rules":
        return {
          ...prev,
          Rules: action.data,
        };
      case "createContact":
        return {
          ...prev,
          createContact: {
            ...prev.createContact,
            [action.field]: action.value,
          },
        };
      default:
        return prev;
    }
  }, useSelector(selectEventHandler(uuid)));

  const ehdispatch = useDispatch();

  useEffect(() => {
    const timeout = setTimeout(() => {
      ehdispatch(setEventHandler(state));
    }, 50);
    return () => clearTimeout(timeout);
  }, [state]);

  const toggleModuleHandler = () => {
    dispatch({ type: "toggle-module" });
  };

  return (
    state && (
      <>
        <div>
          <input
            type="text"
            className="form-control input-lg"
            value={state.Label}
            onChange={(e) =>
              dispatch({ type: "edit-label", label: e.target.value })
            }
          />
          <div className="d-flex">
            {event === "form-render" ? (
              <Form.Group
                className="mx-2 my-2"
                controlId={`${state.UUID}-handler-stop-propagation-checkbox`}
              >
                <Form.Check
                  type="checkbox"
                  checked={state.StopPropagation}
                  onChange={() => dispatch({ type: "toggle-stop-propagation" })}
                  label={"Start new page"}
                />
              </Form.Group>
            ) : null}

            {featuresModules && (
              <Form.Group
                controlId={`${state.UUID}-is-module-checkbox`}
                className="mx-2 my-2"
              >
                <Form.Check
                  type="checkbox"
                  checked={state.IsModule}
                  onChange={toggleModuleHandler}
                  label="Module?"
                  disabled={usedIn(state).length > 1}
                />
              </Form.Group>
            )}
          </div>
          <ListenerRules
            event={event}
            listenerRules={state.Rules}
            setListenerRules={(data) =>
              dispatch({ type: "update-rules", data })
            }
          />

          <Form.Group className="my-2" controlId={`${state.UUID}-notes`}>
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={state.Notes || ""}
              onChange={(e) =>
                dispatch({
                  type: "edit-notes",
                  notes: e.target.value,
                })
              }
            />
          </Form.Group>
        </div>

        {state.IsModule && <UsedInLink arg={state} />}
        <JsonCollapse json={state} />
      </>
    )
  );
}
